module.exports = __webpack_public_path__ + "media/workplace/rating-unsure-5144904c.svg";